import Checkbox from '@packages/justo-parts/lib/components/fields/Checkbox'
import SectionAccordion from '@page-components/Checkout/CheckoutV2/shared/SectionAccordion'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function usePriceFilters({priceFilters, setPriceFilters}) {
  const {t} = useTranslation('website', {keyPrefix: 'order.products.productsContent.filters'})
  if (!priceFilters.length) return null

  return (
    <SectionAccordion
      initiallyOpen={true}
      headerTitle={t('labelPriceFilters')}
      containerClassName={styles.containerClassName}
      titleClassName={styles.titleClassName}
      marginClassName={styles.marginClassName}
      arrowClassName={styles.arrowClassName}>
      {priceFilters.map((priceFilter, i) => (
        <div className={styles.filters} key={priceFilter.label}>
          <Checkbox
            key={priceFilter.label}
            label={priceFilter.label}
            value={priceFilter.value}
            onChange={() => {
              priceFilters[i].value = !priceFilters[i].value
              setPriceFilters([...priceFilters])
            }}
          />
          <div className={styles.quantity}>{priceFilter.quantity}</div>
        </div>
      ))}
    </SectionAccordion>
  )
}
